import { render, staticRenderFns } from "./DialogAccountDetails.vue?vue&type=template&id=7c4fd5a5&lang=pug&"
import script from "./DialogAccountDetails.vue?vue&type=script&lang=js&"
export * from "./DialogAccountDetails.vue?vue&type=script&lang=js&"
import style0 from "./DialogAccountDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DialogAccountDetails.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDialog,
  VIcon,
  VSpacer,
  VToolbar,
  VToolbarTitle,
})
